module.exports = __webpack_public_path__ + "static/favicon-9d703c729a77c59a5cdff2cb1b7224e5.ico";